module.exports = __webpack_public_path__ + "img/pass.727eff3f.png";